import { takeLatest } from 'redux-saga/effects';
import { checkService } from './checkService';
import {
  SELECT_PUBLISH_TERMS_SERVICE,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PLACING_TYPE,
  SELECT_PLACING_PERIOD,
  SELECT_PACKAGE,
  CHANGE_AUTO_PROLONG,
  CHANGE_AUCTION_BET,
  SET_CALLTRACKING_ENABLED,
  SET_IS_SERVICES_ENABLED,
} from '../../reducers';
import { SET_TERMS_DURATION } from '../../../actions/termsDurations';

export function* checkoutInfoSagas() {
  yield takeLatest(
    [
      SELECT_PUBLISH_TERMS_SERVICE,
      LOAD_PUBLISH_TERMS_SUCCESS,
      SELECT_PLACING_TYPE,
      SELECT_PLACING_PERIOD,
      SELECT_PACKAGE,
      CHANGE_AUTO_PROLONG,
      CHANGE_AUCTION_BET,
      SET_CALLTRACKING_ENABLED,
      SET_IS_SERVICES_ENABLED,
      SET_TERMS_DURATION,
    ],
    checkService,
  );
}
